import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import toastr from "toastr"

// Login Redux States
import { PARTICIPANT_EDIT_PROFILE, PARTICIPANT_PASSWORD_CHANGE, PARTICIPANT_VIEW_PROFILE } from "./actionTypes"
import { profileParticipantSuccess, profileParticipantError } from "./actions"

import {
  onParticipantPasswordChange,
  onParticipantProfileUpdate, onParticipantProfileView,
} from "helpers/backend_api_helper"

function* viewParticipantProfile({ payload: {  callback } }) {
  try {
    const response = yield call(onParticipantProfileView);
    callback && callback(response)
    yield put(profileParticipantSuccess(response))

  } catch (error) {
    yield put(profileParticipantError(error))
  }
}

function* editParticipantProfile({ payload: { user, callback } }) {
  try {
    const response = yield call(onParticipantProfileUpdate, user);
    yield put(profileParticipantSuccess(response));

    callback && callback(response);
  } catch (error) {
    yield put(profileParticipantError(error))
  }
}

function* passwordParticipantChange({ payload: { data, callback } }) {
  try {
    const response = yield call(onParticipantPasswordChange, data);
    yield put(profileParticipantSuccess(response));

    callback && callback(response);
  } catch (error) {
    toastr.error(error?.response?.data?.message || "Server Error")
    yield put(profileParticipantError(error))
  }
}

export function* watchProfile() {
  yield takeEvery(PARTICIPANT_EDIT_PROFILE, editParticipantProfile)
  yield takeEvery(PARTICIPANT_VIEW_PROFILE, viewParticipantProfile)
  yield takeEvery(PARTICIPANT_PASSWORD_CHANGE, passwordParticipantChange)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
